import { memo, useState } from "react";
import clsx from "clsx";
import _isEqual from "lodash/isEqual";
import {
  PadlockCloseIcon,
  PadlockOpenIcon,
} from "../../../../../../../components/icons/icons";
import { useDailyCalendarTileStyles } from "./dailyCalendarTileStyles";
import moment from "moment/moment";
import {Stack, Typography, Button, Box} from '@mui/material';
import { useDispatch } from "react-redux";
import { removePatientAppointment } from "../../../../../../../store/reducers/appointments";
import { openSnackbar } from "../../../../../../../store/reducers/globals";
import TruncatedText from "../../../../../../../components/ui/text/truncatedText";
import {getConfig} from '../../../../../../../util/configUtil';

const LockedSlotTile = ({ temporaryLock, event, id }) => {
  const dispatch = useDispatch();
  const classes = useDailyCalendarTileStyles();

  const [isBtnExpanded, setIsBtnExpanded] = useState(false);

  const disableActionsEnabled = getConfig('modules.scheduler.disableActionsAfterNow', false);
  const disableActionsMinutes = getConfig('modules.scheduler.disableActionsAfterMinutes', 5);

  const canCancelSlot = disableActionsEnabled ? moment(event?.appointmentReview?.startDate).isAfter(moment().subtract(disableActionsMinutes, 'minute')) : true;

  const handleUnlockSlot = () => {
    dispatch(
      removePatientAppointment(
        event?.appointmentReview?.__id,
        openSnackbar({
          message: `Slot has been successfully unlocked on ${moment(event?.appointmentReview.startDate).format("DD/MM/YYYY HH:mm A")}`,
          type: "success",
        }),
      ),
    );
  };

  return (
    <div
      id={`${event.session.sessionId}${moment(event?.appointmentReview?.startDate).format("HH:mm")}`}
      className={clsx(classes.lockedContainer, classes.animation)}
      style={{
        justifyContent: !temporaryLock ? "center" : "space-between",
        position: "relative",
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        maxWidth="100%"
        px={1}
      >
        {event?.appointmentReview?.endDate &&
          event?.appointmentReview?.startDate && (
            <Typography variant="h6" fontWeight={600} color="#ACAFB3">
              {moment(event?.appointmentReview?.startDate).format("HH:mm")}{" "}
              {" - "}
              {moment(event?.appointmentReview?.endDate).format("HH:mm")}
            </Typography>
          )}

        {event?.appointmentReview?.description && (
          <TruncatedText
            text={event?.appointmentReview?.description}
            fw={500}
            color="#ACAFB3"
            variant="subtitle1"
          />
        )}
      </Stack>

        {!canCancelSlot && (
            <Box sx={{ mt: 1, mr: 2 }} className={classes.unlockSlotButton}>
                <PadlockCloseIcon />
            </Box>
        )}

        {canCancelSlot && (
            <Button
                variant="text"
                color="info"
                onClick={() => canCancelSlot && handleUnlockSlot()}
                className={classes.unlockSlotButton}
                onMouseEnter={() => canCancelSlot && setIsBtnExpanded(true)}
                onMouseLeave={() => canCancelSlot && setIsBtnExpanded(false)}
              >
                {!isBtnExpanded && <PadlockCloseIcon />}

                {isBtnExpanded && (
                  <Stack
                    pl={1}
                    gap={0.5}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    textTransform="none"
                  >
                    Unlock <PadlockOpenIcon />
                  </Stack>
                )}
            </Button>
        )}
    </div>
  );
};

export default memo(LockedSlotTile, _isEqual);
